import {IStation, IImomoResponsePaginated} from '../api/api.types';
import {IStationApi} from '../api/station-api.service';
import {StateService} from 'angular-ui-router';

export default class StationManagerController {
  static $inject = ['$state', 'stationApi', '$location'];

  stations:IStation[];
  selectedStations:IStation[];
  stationsPromise:ng.IPromise<void>;
  siteSearchText: string;
  paginationSettings: {
    offset: number,
    pageSize: number,
    count?: number,
    currentPage?: number
  };
  order:string;
  isOpen:boolean = false;

  constructor(
    private $state:StateService, 
    private stationApi:IStationApi,
    private $location: ng.ILocationService) {

    this.selectedStations = [];
    this.stations = [];
    this.paginationSettings = {
      offset: this.$location.search().offset || 0,
      pageSize: 10,
      currentPage: this.$location.search().offset ? parseInt(this.$location.search().offset) + 1 : 1
    };
    this.order = this.$location.search().order;
    this.onOrderChange = this.onOrderChange.bind(this);
    this.getStations();
  }

  get isStationSelected() {
    return this.selectedStations.length > 0;
  }

  get selectedStation() {
    return this.selectedStations[0];
  }

  newStation = () => {
    this.$state.go('meteostation.creator');
  };

  showHistoricData() {
    this.$state.go('meteostation.historicNorm',
        {stationId: this.selectedStation.id});
  }

  showStationTimeseries() {
    this.$state.go('meteostation.timeseries',
        {stationId: this.selectedStation.id});
  }

  editStation() {
    this.$state.go('meteostation.details',
        {stationId: this.selectedStation.id});
  }

  private getStations() {
    this.stationsPromise = this.stationApi.getPaginatedMeteoStations(this.paginationSettings.pageSize, this.paginationSettings.offset, this.order)
        .then(this.onStationsReady);
  }

  onOrderChange(order: string) {
    this.getStations()
    this.$location.search({
      offset: this.paginationSettings.offset,
      order: this.order
    });
  }

  onPageChange(page: number) {
    this.paginationSettings.offset = page - 1;
    this.getStations();

    this.$location.search({
      offset: this.paginationSettings.offset,
      order: this.order
    });
  }

  onSiteSearchTextChange() {
    this.stationApi.searchMeteoStations(this.siteSearchText)
      .then((stations) => {
        this.stations = stations;
      })
  }

  private onStationsReady = (stationsPaginated:IImomoResponsePaginated<IStation>) => {
    this.stations = stationsPaginated.resources;
    this.paginationSettings.count = stationsPaginated.count;
  }
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/manager.controller.ts
 **/